import { Project } from './project.models';

export const InvestmentStatus = {
  Draft: 0,
  Sent: 1,
  PendingReview: 2,
  UnderReview: 3,
  Accepted: 4,
  Rejected: 5,
  ActiveFunded: 6,
  Completed: 7,
  Cancelled: 8,
  Refounded: 9,
} as const;

export type InvestmentStatusValue =
  (typeof InvestmentStatus)[keyof typeof InvestmentStatus];

export const INVESTMENT_STATUS_PENDING_FOR_DISPLAY = [
  InvestmentStatus.Sent,
  InvestmentStatus.PendingReview,
  InvestmentStatus.UnderReview,
] as const;

export const INVESTMENT_STATUS_ACCEPTED_FOR_DISPLAY = [
  InvestmentStatus.Accepted,
  InvestmentStatus.ActiveFunded,
  InvestmentStatus.Completed,
] as const;

export const isInvestmentStatusAccepted = (status: number): boolean =>
  (INVESTMENT_STATUS_ACCEPTED_FOR_DISPLAY as readonly number[]).includes(
    status,
  );

export const isInvestmentStatusRejected = (status: number): boolean =>
  status === InvestmentStatus.Rejected;

export const isInvestmentStatusPendingForDisplay = (status: number): boolean =>
  (INVESTMENT_STATUS_PENDING_FOR_DISPLAY as readonly number[]).includes(status);

export interface Investment {
  id: string;
  userId: string | null;
  legalEntityId: string | null;
  projectId: string | null;
  status: number;
  identifier: string | null;
  amount: number;
  interest: number;
  comment: string | null;
  createdDate: string;
  sentDate: string | null;
  decidedDate: string | null;
  fundedDate: string | null;
  completedDate: string | null;
  cancelledDate: string | null;
  refeusedDate: string | null;
  investorIsExperienced: boolean;
  pendingUntil: string | null;
  decidedByUserId: string | null;
  decisionNote: string | null;
  investmentProtection: boolean;
  creationDate: string;
  creationUser: string | null;
  modificationDate: string | null;
  modificationUser: string | null;
  projectName: string | null;
  projectCurrency: string | null;
  accountOwner: string | null;
  accountNumber: string | null;
}

export interface AcceptedInvestmentResponse extends Investment {
  project: Project;
  bankAccountName?: string | null;
  bankAccountNumber?: string | null;
}

export type InvestmentWithProject = Investment & { project?: Project };
